import AppReviews from "@/features/app-reviews"
import createComponent from "@/utils/create-component"

const element = document.querySelector("#r-app-reviews")

if (element) {
  const { hideCta, ctaCopy } = element.dataset

  createComponent({
    el: "#r-app-reviews",
    component: AppReviews,
    props: {
      hideCta: hideCta === "true",
      ctaCopy: ctaCopy
    }
  })
}
